module.exports = __webpack_public_path__ + "img/slide10.aa065027.png";